export default __webpack_public_path__ + "static/samsung-thumbnail-035b82af6ab8f48c1000c04726af1d81.png";